import type { FunctionComponent } from 'react';

export const LanguageSkillIcon: FunctionComponent<{
    readonly color?: string;
}> = ({ color = '#6E6E6C' }) => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg
            fill="none"
            style={{ minHeight: '12px', minWidth: '12px' }}
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                fill={color}
                height="26.7586"
                rx="0.590514"
                transform="rotate(-90 2.7627 22.9294)"
                width="14.1663"
                x="2.7627"
                y="22.9294"
            />
        </svg>
    );
};
